import { flattenClassNames } from '@trukt/portal-utils/flattenClassNames';
import { ReactNode } from 'react';

interface ContentProps {
  className?: string;
  children: ReactNode;
}

export const Content = ({ children, className }: ContentProps) => {
  return (
    <section
      className={flattenClassNames(['relative bottom-2.5 row-start-2 row-end-3 h-full', className])}
    >
      {children}
    </section>
  );
};
